import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InvoiceService } from 'src/app/services/http/business/invoice/invoice.service';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {
  branchInfo = {};
  invoice: any = {};
  // InvoiceRejectCauseId: any;
  // PayCash:boolean=false;
  dataSource: any = [];
  displayedColumns: string[] = [
    "date",
    "debtor",
    "creditor",
    "description",
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private invoiceService: InvoiceService,
    private dialog: MatDialogRef<InvoiceDetailsComponent>
  ) { }

  ngOnInit() {
    if (this.data.isStudent)
      this.getInvoiceById();
    else
      this.getInvoiceInfoById();
  }


  getInvoiceById() {
    const queryParams = {
      Id: this.data.Id
    }
    this.invoiceService
      .getInvoiceVoucherRowForStudent(queryParams)
      .subscribe(res => {
        console.log(res);

        this.invoice = res[0];
        this.invoice.Branch = JSON.parse(this.invoice.Branch);
        //this.invoice.VoucherRows = JSON.parse(this.invoice.VoucherRows);
        this.invoice.Amounts = JSON.parse(this.invoice.Amounts);
        this.invoice.PersonAddress = JSON.parse(this.invoice.PersonAddress);
        var _r = [];
        res.forEach(elements => {
          JSON.parse(elements.VoucherRows).forEach(element => {
            _r.push(element);
          });
        });
        this.dataSource = _r;
      });

  }

  getInvoiceInfoById() {
    const queryParams = {
      Id: this.data.Id
    }
    this.invoiceService.getInvoiceInfoById(queryParams)
      .subscribe(res => {
        console.log(res);

        this.invoice = res[0];
        this.invoice.Branch = JSON.parse(this.invoice.Branch);
        //this.invoice.VoucherRows = JSON.parse(this.invoice.VoucherRows);
        this.invoice.Amounts = JSON.parse(this.invoice.Amounts);
        this.invoice.PersonAddress = JSON.parse(this.invoice.PersonAddress);
        var _r = [];
        res.forEach(elements => {
          JSON.parse(elements.VoucherRows).forEach(element => {
            _r.push(element);
          });
        });
        this.dataSource = _r;
      });
  }

  print() {
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('</head><body style="direction: rtl;font-family: B Nazanin;" >');
    mywindow.document.write(document.getElementById('printArea').innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    //mywindow.close();

    // return true;
  }

  onNoClick(): void {
    this.dialog.close();
  }
}
